// apps/djayma/src/lib/admin-theme.ts

export const ADMIN_THEME = {
  sidebar: {
    bg: "#C75B39",
    bgDark: "#9E3E22",
    text: "rgba(255,248,240,0.65)",
    textActive: "#FFF8F0",
    activeBg: "rgba(255,248,240,0.2)",
    hoverBg: "rgba(255,248,240,0.1)",
    sectionLabel: "rgba(255,248,240,0.4)",
    border: "rgba(255,248,240,0.15)",
    logoBg: "#FFF8F0",
    logoText: "#C75B39",
  },
  content: {
    bg: "#FAF6F0",
    border: "#e7e0d6",
  },
  accent: {
    gold: "#D4A535",
    green: "#2D5A3D",
  },
  login: {
    bgFrom: "#C75B39",
    bgTo: "#9E3E22",
    card: "#FFF8F0",
    button: "#C75B39",
  },
} as const;

export type AdminTheme = typeof ADMIN_THEME;
